import React, { useState, useContext, useEffect, useRef } from 'react';
import { Field } from 'formik';
import InputField from '../Form/InputField';
import { AuthContext, LoaderContext } from '../../contexts';
import ComboBox from '../Form/ComboBox3';
import CheckBox from '../Form/CheckBoxFormSection';
import CheckBoxGroup from "../Form/CheckBoxGroup";
import MultiSelectField from '../Form/MultiSelectField';
import SearchField from '../Form/SearchField';
import _, { camelCase, debounce, isObject, uniqueId } from 'lodash';
import { DayPicker } from "react-day-picker";
import Label from '../Form/Label';
import Switch from 'react-switch';
import Colors from 'constants/Colors';
import TextField from '../Form/TextField';
import Icon from '../Icon';
import moment from 'moment';
import TextEditorBox from "../TextEditorBox";
import NotesAccordionV2 from '../NotesAccordionV2';
import RadioButtonGroup from "../Form/Radio/RadioButtonGroup";
import { useGetPersonsSync, useGetSicCode } from '../../services/PersonService';
import {
    useGetCountries,
    useGetZipCode,
    useGetSerpro,
    useGetSerproEnterprise,
    useGetQuery,
    useGetDomainStatus
} from '../../services/QuestionnairesService';
import { useGetProductPlans } from '@fitinsur/services/ProductPlanService';
import { useGetProducts } from '@fitinsur/services/ProductService';
import { useGetGroupSuseplob } from '@fitinsur/services/GroupSuseplobService';
import { MessageCenter } from '../../utils';

import { FieldWrapper, Container, CalendarContainer, BorderSwitch, AddButton, BottomSeparatorLine } from './styles'
import DragZoneUpload from '../DragZoneUpload/index';
import TagsList from '../TagList/index';
import ModalConfirmation from '../ModalConfirmation';
import ptBR from 'date-fns/locale/pt-BR';

const getFieldComponent = (question) => {
    const { idDomainQuestion, idQuestion, behaviorObject } = question;

    if (idDomainQuestion === 42) {
        switch (behaviorObject?.componentId) {
            case "TextEditorBox": return TextEditorBox;
            case "TextField": return TextField;
            case "NotesAccordion": return NotesAccordionV2;
            default: return InputField;
        }
    } else if (idDomainQuestion == 43) {
        switch (behaviorObject?.componentId) {
            case "RadioButton": return RadioButtonGroup;
            case "CheckBox": return CheckBox;
            default: return ComboBox;
        };
    } else if (idDomainQuestion === 44) {
        switch (behaviorObject?.componentId) {
            case "CheckBox": return CheckBoxGroup;
            default: return MultiSelectField;
        };
    } else if (idDomainQuestion === 276) {
        return SearchField;
    } else if (idDomainQuestion === 295) {
        return InputField;
    } else if (idDomainQuestion === 277) {
        return InputField;
    }
}

const getOptions = (question, idProduct, idDomainStatusFilter) => {
    if (![43, 44, 270, 271].includes(question.idDomainQuestion)) return [];

    if (question.answerOptions) {
        const answerOptions = question.answerOptions.map(answerOption => {
            let behavior = {}
            let behaviorObject = answerOption.behaviorObject || {};

            if (idDomainStatusFilter) {
                if (
                    !Array.isArray(answerOption?.behaviorObject?.idDomainStatusFilter) &&
                    answerOption?.behaviorObject?.idDomainStatusFilter !== idDomainStatusFilter
                ) {
                    return null;
                } else if (
                    Array.isArray(answerOption?.behaviorObject?.idDomainStatusFilter) &&
                    !answerOption?.behaviorObject?.idDomainStatusFilter.includes(idDomainStatusFilter)
                ) {
                    return null;
                }
            }

            try {
                behavior = JSON.parse(answerOption.behaviorAnswerOption) || {}
            } catch (e) {
                //console.error('GET OPTIONS - Error in parse Behavior')
            }

            if (behavior?.isResultProduct) {
                const hasProduct = behavior.resultIdProduct.some(resultId => resultId == idProduct);

                if (hasProduct) {
                    return {
                        label: answerOption.dsAnswerOption,
                        expireDateAnswerOption: answerOption.expireDateAnswerOption,
                        value: {
                            idAnswerOption: answerOption.idAnswerOption,
                            dsAnswerOption: answerOption.dsAnswerOption,
                            resultValue: behavior.resultValue != null ? behavior.resultValue : null,
                        }
                    }
                }
            } else {
                return {
                    label: answerOption.dsAnswerOption,
                    expireDateAnswerOption: answerOption.expireDateAnswerOption,
                    value: {
                        idAnswerOption: answerOption.idAnswerOption,
                        dsAnswerOption: answerOption.dsAnswerOption,
                        resultValue: behavior.resultValue != null ? behavior.resultValue : null,
                    },
                    isReadOnly: behaviorObject?.isReadOnly,
                }
            }
        })

        return answerOptions.filter(Boolean);
    }

    return [];
}

const getQuestionAnswer = (question, setFieldValue) => {
    if (!question) return '';
    if (question.answer == null) question.answer = '';

    //question with options answer
    if (question.idDomainQuestion === 43) {
        if (isNaN(question.behaviorObject.defaultValue)) question.behaviorObject.defaultValue = null;
        if (!question?.idAnswerOption && !question.behaviorObject.defaultValue && question.behaviorObject.componentId === 'Switch') {
            const currentAnswerOption = question?.answerOptions?.find((x) => x.dsAnswerOption?.toUpperCase() === 'NO');
            if (currentAnswerOption) {
                question.idAnswerOption = currentAnswerOption.idAnswerOption
                question.behaviorObject.defaultValue = currentAnswerOption.idAnswerOption;
            }
        }

        if (!question?.idAnswerOption && !question.behaviorObject.defaultValue) return;
        if (!question?.idAnswerOption && question.behaviorObject.defaultValue && !isNaN(question.behaviorObject.defaultValue)) question.idAnswerOption = question.behaviorObject.defaultValue;
        if (!question.idAnswerOption) return;

        let dsAnswerOption;
        let resultValue = null;
        try {
            const currentAnswerOption = question?.answerOptions?.find((x) => x.idAnswerOption === question?.idAnswerOption);
            const { behaviorObject } = currentAnswerOption || {};

            dsAnswerOption = currentAnswerOption?.dsAnswerOption;
            resultValue = behaviorObject?.resultValue != null ? behaviorObject?.resultValue : null;
        } catch (err) {
            console.error(`quotation-edit - checkType: idAnswerOption: ${question.idAnswerOption} - ERROR: ${err.message}`);
        }

        if (!question.answer && dsAnswerOption) question.answer = (resultValue != null ? resultValue : dsAnswerOption) || "";
        setFieldValue && setFieldValue(question.key, {
            idAnswerOption: question?.idAnswerOption,
            dsAnswerOption: dsAnswerOption || "",
            resultValue
        });
        return;
    }

    //questions with calendar
    if (question.behaviorObject.rightIcon === "calendar") {
        let formattedDate = "";
        const dateAnswer = question?.answer || question.behaviorObject?.defaultValue;
        if (dateAnswer) {
            let momentDate = moment(dateAnswer, 'YYYY-MM-DD');
            if (momentDate.isValid()) {
                formattedDate = momentDate.format(question.behaviorObject.fieldDateFormat || 'MM/DD/YYYY');
                question.answer = momentDate.format("YYYY-MM-DD");
            }
        }

        question.answer = question.answer
        setFieldValue && setFieldValue(question.key, formattedDate);
        return;
    }

    if (question.idDomainQuestion === 270 || question.idDomainQuestion === 271) {
        try {
            let answerJson = JSON.parse(question.answerJson) || [];
            question.answer = answerJson
        } catch (error) {
            if (Array.isArray(question.answer)) {
                question.answer = question.answerJson;
            } else {
                question.answer = []
            }
            //console.log('ERROR IN PARSE', question);
            return;
        }
    }

    //question with string or json answer
    try {
        let answerJson = JSON.parse(question.answerJson);

        if (answerJson && answerJson.constructor === Object) {
            question.answer = question?.answer || question.behaviorObject.defaultValue || ''
            setFieldValue && setFieldValue(question.key, answerJson?.value || question.behaviorObject.defaultValue || '');
            return;
        } else {
            question.answer = question?.answer || question.behaviorObject.defaultValue || ''
            setFieldValue && setFieldValue(question.key, question?.answer || question.behaviorObject.defaultValue || '');
            return;
        }
    } catch (error) {
        //console.log('ERROR IN PARSE', question);
        question.answer = question?.answer || question.behaviorObject.defaultValue || ''
        setFieldValue && setFieldValue(question.key, question?.answer || question.behaviorObject.defaultValue || '');
        return;
    }
}

const getDisableDays = (days) => {
    if (days == null) {
        return null;
    };
    const date = new Date();
    return new Date(date.setDate(date.getDate() + (days)));
};

export default function FormSection({
    sectionName,
    questionnaire,
    values,
    setFieldValue,
    sectionIndex,
    extraButtons,
    extraButtonsQuestion,
    onQuestionChange,
    periodicityText,
    periodicityOptions,
    idProduct,
    onClickCreatePerson,
    operationIdPerson,
    disableAll,
    errors,
    setFieldError,
    idDomainStatusFilter,
    singleUpload,
    onBlur,
    canGenerate,
    question901SearchAllCountry,
    currentModality,
    ignoreModality,
    refreshCompanyClientInformation,
    onRequestSerproCnpj,
    showWarning,
    format,
    onSearchZipCode,
    permissions = {},
    setQuestionnaire,
    customTagListBg,
    selectedBrokers,
    selectedCoInsurers,
    debounceSearchRequest = true,
    searchRequestDebounceMS,
    notChangeQuestions = [],
    brokerIdSelected,
    isEconomicGroup,
    extraLeftChildren,
    verticalAlign,
    isExternal,
    operation,
    questionExtraContentRight,
    onFileUploadSuccess,
    onFileRemoveSuccess,
}) {
    const mc = new MessageCenter();
    const authContext = useContext(AuthContext);
    const [showCalendar, setShowCalendar] = useState("");
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const isMultipleFormSection = sectionIndex != null;
    const permissionsValues = Object.values(permissions);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [modalPromise, setModalPromise] = useState({ resolve: () => { }, reject: () => { } });

    const {
        request: getPersonRequest,
    } = useGetPersonsSync();

    const {
        request: getSicCodeRequest,
    } = useGetSicCode();

    const {
        request: getCountryRequest,
    } = useGetCountries();

    const {
        request: getSerproRequest,
    } = useGetSerproEnterprise();

    const {
        request: getZipCodeRequest,
    } = useGetZipCode();

    const {
        request: useGetQueryRequest,
    } = useGetQuery();

    const {
        request: useGetDomainStatusRequest,
    } = useGetDomainStatus();

    const {
        request: useGetProductPlansRequest,
    } = useGetProductPlans();

    const {
        request: useGetProductsRequest,
    } = useGetProducts();

    const {
        request: useGetGroupSuseplobRequest,
    } = useGetGroupSuseplob();

    const cpfValidation = (cpf) => {
        let sum;
        let rest;
        sum = 0;
        if (cpf == "00000000000") return false;

        for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        rest = (sum * 10) % 11;

        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(9, 10))) return false;

        sum = 0;
        for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        rest = (sum * 10) % 11;

        if ((rest == 10) || (rest == 11)) rest = 0;
        if (rest != parseInt(cpf.substring(10, 11))) return false;
        return true;
    }

    const cnpjValidation = (cnpj) => {
        let position = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

        if (cnpj.length !== 14)
            return false

        if (/0{14}/.test(cnpj))
            return false

        for (var i = 0, n = 0; i < 12; n += cnpj[i] * position[++i]);
        if (cnpj[12] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        for (var i = 0, n = 0; i <= 12; n += cnpj[i] * position[i++]);
        if (cnpj[13] != (((n %= 11) < 2) ? 0 : 11 - n))
            return false

        return true
    }

    const validateCpfCnpj = async (question, searchValue, queryId) => {

        let message = ""
        if (question.behaviorObject?.fieldMask === "cpf") {
            if (!cpfValidation(searchValue)) message = `CPF ou CNPJ inválido`
        }

        if (question.behaviorObject?.fieldMask === "cnpj") {
            if (!cnpjValidation(searchValue)) message = `CPF ou CNPJ inválido`
        }

        if (question.behaviorObject?.fieldMask === "cpfCnpj") {
            if (searchValue && searchValue.length > 11) {
                if (!cnpjValidation(searchValue)) message = `CPF ou CNPJ inválido`
            } else if (searchValue) {
                if (!cpfValidation(searchValue)) message = `CPF ou CNPJ inválido`
            }
        }

        if (message) {
            setFieldError && setFieldError(question.key, message)
            mc.error(message);
        }
    }


    const handleOnChange = (question, value, questionnaire) => {
        if (question.disabled || question.behaviorObject.isReadOnly || question.behaviorObject.rightIcon === 'calendar') return;

        setFieldValue && setFieldValue(question.key, value);
        let questionnaireUpdated = questionnaire;

        if (!question.behaviorObject.searchQueryId || value === '') {
            const idAnswerOption = isObject(value) && value.idAnswerOption ? value.idAnswerOption : undefined;
            const answer = idAnswerOption ?
                (value.resultValue != null ? value.resultValue : value.dsAnswerOption) :
                isObject(value) ?
                    JSON.stringify(value) :
                    value;

            questionnaireUpdated = questionnaire.map(v => v.key === question.key ?
                ({
                    ...v, idAnswerOption,
                    answer: answer === '' ? v.answerJson = '' : answer,
                    answerJson: idAnswerOption ? undefined : v.answerJson
                }) : v)

            setQuestionnaire(questionnaireUpdated);
        }
        onQuestionChange && onQuestionChange(question, value, setFieldValue, questionnaireUpdated)
    };


    const debounceOnChange = useRef(debounce((question, value, questionnaire) => handleOnChange(question, value, questionnaire), 50))
        .current;

    //search request for search field types based on behavior
    const searchRequest = async (searchValue, question, setSearchList) => {
        try {
            let qstBehavior = question.behaviorObject;

            if (qstBehavior && qstBehavior.searchQueryId === 'person') {
                const query = { getContacts: true, getSicCode: true };

                if (qstBehavior.searchQueryFieldId === 'legalPersonId' && !searchValue) {
                    searchValue = 'xxxxxxxxxxxxxxxx'
                }

                query[qstBehavior.searchQueryFieldId] = searchValue;

                if (qstBehavior.searchIndividuals) {
                    query.idPersonRoot = authContext.idPersonRoot;
                    query.idDomain = 34
                } else {
                    if (qstBehavior.searchOperationIdPerson && operationIdPerson) {
                        query.idPersonRoot = operationIdPerson;
                    }
                    query.idDomain = 35
                }

                const { data } = await getPersonRequest(null, query);

                const persons = data.value.map(person => ({
                    ...person,
                    value: query.idDomain === 34 ? `${person.personFirstName} ${person.personLastName}` : person.personLastName,
                    id: person.idPerson
                }));

                return setSearchList(persons);
            }

            if (qstBehavior && qstBehavior.searchQueryId === 'sicCode') {
                const query = { sicType: 'TEXEL_MERIDIAN_US', searchValue };

                const { data } = await getSicCodeRequest(null, query);

                const sicCodes = data.value.map(sicCode => ({
                    ...sicCode,
                    value: sicCode.sicCode + " - " + sicCode.sicDescription,
                    id: sicCode.sicCode
                }));

                return setSearchList(sicCodes);
            }

            if (qstBehavior && qstBehavior.searchQueryId === 'country') {
                const query = { country: searchValue };

                if (!question901SearchAllCountry) {
                    if (question.idQuestion == 901) {
                        query.countryIds = [242, 221] //221 USA
                    }
                }

                const { data } = await getCountryRequest(null, query);

                const countries = data.value.map(country => ({
                    ...country,
                    value: country.countryName,
                    id: country.idCountry

                }));
                return setSearchList(countries);
            }

            if (qstBehavior?.searchQueryId === 'fitQueryPersonClient' || qstBehavior?.searchQueryId === 'fitQueryPersonClientLegalEntities' || qstBehavior?.searchQueryId === 'fitQueryPersonBroker') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        queryTail: qstBehavior?.searchQueryId === 'fitQueryPersonClient' || qstBehavior?.searchQueryId === 'fitQueryPersonBroker',
                        personName: searchValue,
                        legalPersonId: searchValue,
                        brokerIdSelected: qstBehavior?.brokerIdSelected || brokerIdSelected || null,
                        selectedBrokers: selectedBrokers,
                        questionId: question.idQuestion
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: (qstBehavior?.searchQueryId !== 'fitQueryPersonClient' || qstBehavior?.searchQueryId !== 'fitQueryPersonBroker') ? `${person.insurerBrokerId || person.legalPersonId || person.id} - ${person.personName}` : person.personName,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (qstBehavior?.searchQueryId === 'fitQueryPersonEconomicGroup') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        legalPersonId: searchValue,
                        questionId: question.idQuestion,
                        isEconomicGroup: isEconomicGroup,
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: `${person.legalPersonId} - ${person.personLastName}`,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (['fitGetProductPerson'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        legalPersonId: searchValue,
                        questionId: question.idQuestion,
                    }
                });
                try {
                    if (data.ret_code !== 200) return;
                    let value = data.ret_value;
                    if (question.searchValue) {
                        const idDomainRoot = data.ret_value.find(product => question.searchValue === product.ID_PRODUCT)
                        value = data.ret_value.filter(product => idDomainRoot.ID_DOMAIN === product.ID_DOMAIN)
                    }
                    const products = value.map(product => ({
                        ...product,
                        value: `${product.ID_PRODUCT} - ${product.PRODUCT_NAME}`,
                        id: product.ID_PRODUCT
                    }));
                    return setSearchList(products);
                } catch (err) {
                    console.log("err product", err)
                };
            }

            if (['fitGetOperationType'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        idProduct: question.searchValue.idProduct
                    }
                });
                try {
                    if (data.ret_code !== 200) return;
                    let value = data.ret_value;
                    if (question.searchValue.idOperation) {
                        const { idDomainRoot } = data.ret_value.find(operation => question.searchValue.idOperation === operation.idDomain)
                        value = data.ret_value.filter(operation => idDomainRoot === operation.idDomainRoot)
                    }
                    const operations = value.map(operation => ({
                        ...operation,
                        value: `${operation.idDomain} - ${operation.descriptionDomain}`,
                        id: operation.idDomain
                    }));
                    return setSearchList(operations);
                } catch (err) {
                    console.log("err operation", err)
                };
            }

            if (['fitGetStatusType'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetDomainStatusRequest(null, {
                    idDomain: question.searchValue
                });
                try {
                    if (data.statusCode !== 200) return;
                    let newValue = data.value;
                    if (data.value.length === 26) newValue = data.value.splice(0, 8);
                    const status = newValue.map(s => ({
                        ...s,
                        value: `${s.idDomainStatus} - ${s.statusDescription}`,
                        id: s.idDomainStatus
                    }));
                    return setSearchList(status);
                } catch (err) {
                    console.log("err status", err)
                };
            }

            if (['fitGetProductPlan'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetProductPlansRequest(null, {
                    idsProduct: [question.searchValue]
                });
                try {
                    if (data.statusCode !== 200) return;
                    const plans = data.value.map(plan => ({
                        ...plan,
                        value: `${plan.idProductPlan} - ${plan.productPlanName}`,
                        id: plan.productPlanName
                    }));
                    return setSearchList(plans);
                } catch (err) {
                    console.log("err plans", err)
                };
            }

            if (['fitGetProducts'].includes(qstBehavior?.searchQueryId)) {
                const { data: { value } } = await useGetProductsRequest();
                try {
                    const products = value.map(product => ({
                        ...product,
                        value: product.productName,
                        id: product.idProduct
                    }));

                    return setSearchList(products);
                } catch (err) {
                    console.log("err products", err)
                };
            }

            if (['fitGetInsurerFilialRelation'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        filial: searchValue
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: `${person.personLastName} - ${person.insurerLegalEntityId}`,
                        id: person.idPerson
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err broker", err)
                };
            }

            if (['fitGetProductRegionList'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        langCode: searchValue
                    }
                });
                try {
                    if (data.ret_code !== 200) return;
                    const regions = data.ret_value.map(region => ({
                        ...region,
                        value: `${region.langCode} - ${region.langName}`,
                        id: region.idRegion
                    }));
                    return setSearchList(regions);
                } catch (err) {
                    console.log("err regions", err)
                }
            }

            if (['fitGetProductsRoot'].includes(qstBehavior?.searchQueryId)) {
                try {
                    const { data: { ret_value } } = await useGetQueryRequest({
                        id: qstBehavior?.searchQueryId,
                        params: {
                            productName: searchValue,
                        }
                    });
                    const result = ret_value
                        .map(product => ({
                            ...product,
                            value: product.productName,
                            id: product.idProduct
                        }))
                        .sort((a, b) => a.productName.localeCompare(b.productName));

                    return setSearchList(result);
                } catch (err) {
                    console.log("err products", err);
                };
            }

            if (['fitGetCoveragesByGroupAndRamo'].includes(qstBehavior?.searchQueryId)) {
                try {
                    const { data: { ret_value } } = await useGetQueryRequest({
                        id: qstBehavior?.searchQueryId,
                        params: {
                            coverageName: searchValue,
                            groupNumber: question.behaviorObject?.groupNumber,
                            ramoNumber: question.behaviorObject?.ramoNumber
                        }
                    });
                    const result = ret_value
                        .map(coverage => ({
                            ...coverage,
                            value: `${coverage.coverageName}`,
                            id: coverage.idCoverage
                        }))
                        .sort((a, b) => a.idCoverage - b.idCoverage);

                    return setSearchList(result);
                } catch (err) {
                    console.log("err products", err);
                };
            }

            if (['fitGetGroupSuseplobGrupo'].includes(qstBehavior?.searchQueryId)) {
                try {
                    let groupName = searchValue, groupNumber = false;

                    if (searchValue.match(/\d+/)) {
                        groupName = '';
                        groupNumber = searchValue.match(/\d+/)[0];
                    }

                    const { data: { ret_value } } = await useGetQueryRequest({
                        id: qstBehavior?.searchQueryId,
                        params: {
                            groupName,
                            groupNumber,
                            ramoNumber: question.behaviorObject.ramoNumber
                        }
                    });
                    const result = ret_value
                        .map(groupSuseplob => ({
                            ...groupSuseplob,
                            value: `${groupSuseplob.groupNumber} - ${groupSuseplob.groupName}`,
                            id: groupSuseplob.groupNumber
                        }))
                        .sort((a, b) => a.idCoverage - b.idCoverage);

                    return setSearchList(result);
                } catch (err) {
                    console.log("err products", err);
                }
            }

            if (['fitGetFramingList'].includes(qstBehavior?.searchQueryId)) {
                try {
                    const { data: { ret_value } } = await useGetQueryRequest({
                        id: qstBehavior?.searchQueryId,
                        params: {
                            idAnswerOption: question.searchValue,
                            idQuestion: question.searchValueQuestion
                        }
                    });
                    const result = ret_value
                        .map(item => ({
                            ...item,
                            value: item.idQuestion ? `${item.idQuestion} - ${item.dsQuestion}` :
                                item.columnName ?? `${item.idAnswerOption} - ${item.dsAnswerOption}`,
                            id: item.idAnswerOption ? item.idAnswerOption : item.idQuestion ?? null
                        }))

                    return setSearchList(result);
                } catch (err) {
                    console.log("err questionnaire", err);
                }
            }

            if (['fitGetGroupSuseplobRamo'].includes(qstBehavior?.searchQueryId)) {
                try {
                    let ramoName = searchValue, ramoNumber = false;

                    if (searchValue.match(/\d+/)) {
                        ramoName = '';
                        ramoNumber = searchValue.match(/\d+/)[0];
                    }

                    const { data: { ret_value } } = await useGetQueryRequest({
                        id: qstBehavior?.searchQueryId,
                        params: {
                            ramoName,
                            ramoNumber,
                            groupNumber: question.behaviorObject.groupNumber
                        }
                    });
                    const result = ret_value
                        .map(groupSuseplob => ({
                            ...groupSuseplob,
                            value: `${groupSuseplob.ramoNumber} - ${groupSuseplob.ramoName}`,
                            id: groupSuseplob.ramoNumber
                        }))
                        .sort((a, b) => a.ramoNumber - b.ramoNumber);

                    return setSearchList(result);
                } catch (err) {
                    console.log("err products", err);
                };
            }

            if (['fitQueryPersonWithGDPROnlyLegal', 'fitQueryPersonWithGDPR'].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        legalPersonId: searchValue,
                        questionId: question.idQuestion,
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: `${person.legalPersonId} - ${person.personLastName}`,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (["fitQueryBorrowerRepresentative", "fitGetSompoInsured"].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        legalPersonId: searchValue,
                        borrowerId: 554875 //554875
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: `${person.name || person.personName}${person.CONTACT_DESCRIPTION ? ` - ${person.CONTACT_DESCRIPTION}` : ''}`,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (["fitGetSompoCoInsurers"].includes(qstBehavior?.searchQueryId)) {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        id: qstBehavior?.searchQueryId,
                        personName: searchValue,
                        selectedCoInsurers: selectedCoInsurers
                    }
                });

                try {
                    if (data.ret_code !== 200) return;

                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: person.value,
                        id: person.id
                    }));
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err cnpj", err)
                };
            }

            if (qstBehavior?.searchQueryId === 'fitGetGroupsByName') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        groupName: searchValue,
                        idAccessGroup: question.behaviorObject?.idAccessGroup || null,
                        userManagement: question.behaviorObject.sectionName === 'USER_ACCESS_GROUP',
                        ...(typeof question.behaviorObject.isExternal === 'boolean' && {
                            isExternal: question.behaviorObject.isExternal,
                        }),
                        idAccessGroups: question.idAccessGroups || [],
                    }
                });

                try {
                    if (data.ret_code !== 200) return;
                    const groups = data.ret_value.map(group => ({
                        ...group,
                        value: group.groupName,
                        id: group.idGroup
                    }));
                    return setSearchList(groups);
                } catch (err) {
                    console.log("err fitGetGroupsByName", err)
                };
            }

            if (qstBehavior?.searchQueryId === 'fitGetProfileByName') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        roleName: searchValue,
                        ...(typeof question.behaviorObject.isExternal === 'boolean' && {
                            isExternal: question.behaviorObject.isExternal,
                        })
                    }
                });

                try {
                    if (data.ret_code !== 200) return;
                    const roles = data.ret_value.map(role => ({
                        ...role,
                        value: role.roleName,
                        id: role.idRole
                    }));
                    return setSearchList(roles);
                } catch (err) {
                    console.log("err fitGetProfileByName", err)
                };
            }

            if (qstBehavior?.searchQueryId === 'fitGetUserByUserName') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        userName: searchValue
                    }
                });

                try {
                    if (data.ret_code !== 200) return;
                    const users = data.ret_value.map(user => ({
                        ...user,
                        value: user.userName,
                        id: user.idUser
                    }));
                    console.log(users);
                    return setSearchList(users);
                } catch (err) {
                    console.log("err fitGetUserByUserName", err)
                };
            }

            if (qstBehavior?.searchQueryId === 'fitQueryPersonEconomicGroupByOperation') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        idOperation: operation?.idOperation
                    }
                });

                try {
                    if (data.ret_code !== 200) return;
                    const persons = data.ret_value.map(person => ({
                        ...person,
                        value: person.legalPersonId,
                        id: person.idPerson
                    }));
                    console.log(persons);
                    return setSearchList(persons);
                } catch (err) {
                    console.log("err fitQueryPersonEconomicGroupByOperation", err)
                };
            }

            if (qstBehavior?.searchQueryId === 'fitGetProductTypes') {
                const { data } = await useGetQueryRequest({
                    id: qstBehavior?.searchQueryId,
                    params: {
                        productType: searchValue
                    }
                });

                try {
                    if (data.ret_code !== 200) return;
                    const productTypes = data.ret_value.map(productType => ({
                        ...productType,
                        value: productType.domainDescription,
                        id: productType.idDomain
                    }));

                    // filtrando para aparecer somente o tipo de produto seguro - idDomain: 19 
                    const productTypesFiltered = productTypes.filter(productType => productType.id === 19);

                    return setSearchList(productTypesFiltered);
                } catch (err) {
                    console.log("err fitGetProductTypes", err)
                };
            }
            return;
        } catch (err) {
            console.log("FETCH_FAILURE: ", err);
            return;
        }
    }

    const searchSerpro = async (question, searchValue, queryId, questionnaire, setFieldValue, adHoc = false) => {

        if (question.behaviorObject?.fieldMask === "cpfCnpj" || question.behaviorObject?.fieldMask === "cpf") {
            validateCpfCnpj(question, searchValue, queryId);
        }

        if (searchValue && searchValue.length <= 11) return;

        if (queryId !== "fitGetSerproCpnj" || !searchValue) return;

        try {
            updateIsLoadingStatus(true)
            const { data } = await getSerproRequest(null, { id: searchValue, draft: true })
            if (data.ret_code !== 200) {
                onRequestSerproCnpj && onRequestSerproCnpj(question, { ni: searchValue }, setFieldValue, adHoc)
                data.ret_value.trim() === "Nenhum registro encontrado."
                    ? mc.error(`${data.ret_value}`)
                    : mc.error("Erro durante a Consulta do CNPJ/CPF")
                return "";
            }

            onRequestSerproCnpj && onRequestSerproCnpj(question, data.ret_value, setFieldValue, adHoc)
        } catch (err) {
            //onRequestSerproCnpj && onRequestSerproCnpj(question, {}, setFieldValue, adHoc)
            onRequestSerproCnpj && onRequestSerproCnpj(question, { ni: searchValue }, setFieldValue, adHoc)
            mc.error(`Erro durante a Consulta do CNPJ/CPF`);
        } finally {
            updateIsLoadingStatus(false)
        };
    }

    const searchZipCode = async (zipCode, queryId, setFieldValue, question) => {
        if (queryId !== "zipCode") return;
        if (question.disabledSearch) return;

        try {
            updateIsLoadingStatus(true)
            const { data } = await getZipCodeRequest(null, { zipcodeQuery: zipCode })
            if (data.ret_code !== 200) {
                mc.error(`CEP não encontrado!`);
                console.log("searchZipCode", data);
                return;
            }

            if (!data.ret_value.LONG_STREET_NAME) data.ret_value.LONG_STREET_NAME = 'NA';
            if (!data.ret_value.DISTRICT) data.ret_value.DISTRICT = 'NA';

            onSearchZipCode && onSearchZipCode(data.ret_value, setFieldValue, question)
        } catch (err) {
            console.log("searchZipCode", err)
        } finally {
            setTimeout(() => updateIsLoadingStatus(false), 300)
        };
    };

    //observer to send current questionnaire answers externally to other forms
    useEffect(() => {
        // console.log(`$ANSWERS_${sectionName}${sectionIndex != null ? `_${sectionIndex}` : ""}`, questionnaire, values)
        setFieldValue(`$ANSWERS_${sectionName}${sectionIndex != null ? `_${sectionIndex}` : ""}`, questionnaire);
    }, [questionnaire]);

    const handleRefreshPerson = async (question, idPerson) => {
        updateIsLoadingStatus(true)
        const { data, status } = await getPersonRequest(null, {
            getContacts: true,
            getSicCode: true,
            idDomain: 35,
            idPerson
        });

        if (status !== 200 || !data.value.length) return updateIsLoadingStatus(false)

        const person = data.value[0];

        const questionnaireUpdated = questionnaire.map(v => v.key === question.key ? ({
            ...v,
            answerJson: JSON.stringify({ value: person.personLastName, id: person.idPerson }),
            answer: JSON.stringify({ value: person.personLastName, id: person.idPerson })
        }) : v);

        setQuestionnaire(questionnaireUpdated);
        onQuestionChange(
            question,
            { value: person.personLastName, id: person.idPerson, ...person },
            setFieldValue,
            questionnaireUpdated
        )

        return updateIsLoadingStatus(false)
    }

    const handleActionButtons = (question) => {
        if (refreshCompanyClientInformation && !!question.behaviorObject.canRefreshPerson) {
            return <>
                <AddButton
                    type="button"
                    style={{ paddingLeft: 8 }}
                    onClick={() => onClickCreatePerson && onClickCreatePerson(
                        question,
                        setFieldValue,
                        onQuestionChange
                    )}
                >
                    <Icon name="addEdit" />
                </AddButton>
                <AddButton
                    type="button"
                    onClick={() => {
                        try {
                            const { id: idPerson } = JSON.parse(question.answer);
                            handleRefreshPerson(question, idPerson)
                        } catch (error) {
                            return
                        }
                    }}
                >
                    <Icon name="generate" />
                </AddButton>
            </>
        } else if ((!disableAll && !question.disabled) && !!question.behaviorObject.canCreatePerson) {
            return <AddButton
                type="button"
                style={{ paddingLeft: 8 }}
                onClick={() => onClickCreatePerson && onClickCreatePerson(
                    question,
                    setFieldValue,
                    onQuestionChange
                )}
            >
                <Icon name="addEdit" />
            </AddButton>
        } else {
            return <></>
        }
    }

    const handleDelete = () => {
        return new Promise((resolve, reject) => {
            setIsModalVisible(true);
            setModalPromise({ resolve, reject });
        });
    };

    const confirmDelete = () => {
        modalPromise.resolve(true);
        setIsModalVisible(false);
    };

    const confirmCancel = () => {
        modalPromise.resolve(false);
        setIsModalVisible(false);
    };

    return (
        <Container key={`${sectionName}-${sectionIndex}-section`}>
            {(!disableAll) && extraLeftChildren}
            {questionnaire
                .filter(question => {
                    return question.behaviorObject && question.behaviorObject.sectionName === sectionName;
                })
                .filter(question => {
                    const productPlans = question?.productPlans?.map(v => (+v));
                    return ignoreModality || !question.productPlans?.length || productPlans.some(plan => currentModality.includes(plan));
                })
                .map(question => {
                    const idDomainAccessFilter = question?.behaviorObject?.idDomainAccessFilter;
                    const idDomainAccessEditable = question?.behaviorObject?.idDomainAccessEditable;

                    if (idDomainAccessEditable
                        && permissionsValues
                        && (Array.isArray(idDomainAccessEditable)
                            ? idDomainAccessEditable.some(id => permissionsValues.includes(id))
                            : permissionsValues.includes(idDomainAccessEditable))
                    ) {
                        question.behaviorObject.isReadOnly = false;
                    } else if (idDomainAccessEditable && permissionsValues) {
                        question.disabled = true;
                        question.behaviorObject.isReadOnly = true;
                    }

                    if (Array.isArray(idDomainAccessFilter)) {
                        if (!(!idDomainAccessFilter || !permissionsValues || permissionsValues.find(v => v && idDomainAccessFilter.includes(v)))) {
                            question.visibleQuestion = false;
                        }
                    } else {
                        if (!(!idDomainAccessFilter || !permissionsValues || permissionsValues.includes(idDomainAccessFilter))) {
                            question.visibleQuestion = false;
                        }
                    }

                    if (values[question.key] == undefined) getQuestionAnswer(question, setFieldValue);

                    if (!question.key) question.key = `${camelCase(question.dsQuestion)}_${question.idQuestion}${isMultipleFormSection ? `_${sectionIndex}` : ""}_${uniqueId()}`;

                    if (!ignoreModality) {
                        const questionInTheSection = questionnaire.find(qst => qst.key === question.key);
                        if (questionInTheSection) return questionInTheSection;
                    }

                    return question
                }).map((question, questionIndex) => {
                    const fieldComponent = getFieldComponent(question);
                    if (!question.visibleQuestion || question.behaviorObject?.isVisible === false) return <></>;

                    const idAnswerOption = question.idAnswerOption;
                    const answerOptions = question.answerOptions;
                    let warning = false;
                    let refused = false;

                    answerOptions.forEach((option) => {
                        const optionValue = option.idAnswerOption;

                        if (idAnswerOption === optionValue) {
                            if (option.idDomain === 40) {
                                warning = idAnswerOption;
                            } else if (option.idDomain === 38) {
                                refused = idAnswerOption;
                            }
                        }
                    });

                    return (
                        <React.Fragment key={`${questionIndex}-${sectionIndex}-${question.idQuestion}-fragment`}>
                            {question?.behaviorObject?.lineBreak && <div style={{ width: "100%" }} />}
                            <FieldWrapper
                                key={`${questionIndex}-${sectionIndex}-${question.idQuestion}-wrapper`}
                                flex={question.behaviorObject.canCreatePerson || question.behaviorObject.extraDescriptionLeft || question.behaviorObject.displayFlex || question.behaviorObject.componentId === 'Switch'}
                                inline={question.behaviorObject.displayFlex}
                                borderTop={question.behaviorObject.displayFlex}
                                mobileWidth={question.behaviorObject.mobileWidth}
                                tabletWidth={question.behaviorObject.tabletWidth}
                                desktopWidth={question.behaviorObject.desktopWidth}
                                marginTop={question.behaviorObject.marginTop}
                                marginRight={question.behaviorObject.marginRight}
                                paddingRight={question.behaviorObject.paddingRight}
                                verticalAlign={verticalAlign || question.behaviorObject.verticalAlign}
                            >
                                {(question.behaviorObject.extraDescriptionLeft) && (
                                    <Label
                                        hideLabelAsterisk={true}
                                        inline={true}
                                        width={100}
                                        style={{ alignSelf: 'center', marginBottom: 20 }}
                                        bold
                                    >
                                        {question.behaviorObject.extraDescriptionLeft}
                                    </Label>
                                )}

                                {question.idDomainQuestion === 614 && (sectionIndex == null || sectionIndex === 0) &&
                                    <Label
                                        hideLabelAsterisk={true}
                                        inline={true}
                                        style={{ alignSelf: 'flex-start', marginBottom: 20 }}
                                    >
                                        {question.dsQuestion}
                                    </Label>
                                }

                                {/* if question is type text, number, search or select */}
                                {(fieldComponent && question.behaviorObject.componentId !== 'Switch') ?
                                    <Field
                                        warning={showWarning ? warning : null}
                                        refused={showWarning ? refused : null}
                                        warningByHiddenQuestions={question.behaviorObject.isWarningByHiddenQuestions}
                                        refusedByHiddenQuestions={question.behaviorObject.isRefusedByHiddenQuestions}
                                        key={`${questionIndex}-${sectionIndex}-${question.idQuestion}-field`}
                                        extraLabelTop={question.behaviorObject.extraDescriptionTop}
                                        preview={true}
                                        disabled={disableAll || question.disabled || (question.behaviorObject.isReadOnly)}
                                        enableSearch={question.behaviorObject.enableSearch}
                                        readOnly={(question.behaviorObject.isReadOnly || question.behaviorObject.rightIcon === 'calendar')}
                                        mask={question.fieldMask}
                                        fieldMaskBehavior={question.fieldMask}
                                        hasModal={question.behaviorObject.hasModal}
                                        modalDescription={question.behaviorObject.modalDescription}
                                        inline={question.behaviorObject.displayFlex}
                                        isRequired={question.behaviorObject.isRequired}
                                        hideLabelAsterisk={question.behaviorObject.hideDescription}
                                        name={question.key}
                                        fieldName={question.key}
                                        labelDEV={question.behaviorObject.hideDescription ? '' : `${question.idQuestion}-${question.dsQuestion}`}
                                        additionalInfo={question?.behaviorObject?.additionalInfo ? question.behaviorObject.additionalInfo : ''}
                                        infoContent={question?.behaviorObject?.textInformation ? question.behaviorObject.textInformation : ''}
                                        label={question.behaviorObject.hideDescription ? '' : `${question.dsQuestion}`}
                                        placeholder={question.behaviorObject.placeholder || ' '}
                                        type="text"
                                        onBlur={(value) => {
                                            onBlur && onBlur(question, value, setFieldValue, questionnaire)
                                            setTimeout(() => {
                                                searchZipCode(values && values[question.key], question.behaviorObject.searchQueryId, setFieldValue, question);
                                                searchSerpro(question, values && values[question.key], question.behaviorObject.searchQueryId, questionnaire, setFieldValue);
                                            }, 350)
                                        }}
                                        leftIcon={question.behaviorObject.leftIcon}
                                        leftIconText={question.behaviorObject.leftIconText}
                                        questionExtraContentRight={questionExtraContentRight ? () => questionExtraContentRight(question) : null}
                                        rightIcon={question.behaviorObject.rightIcon}
                                        rightIconComponent={extraButtonsQuestion && extraButtonsQuestion(question)}
                                        rightIconClick={() => {
                                            if (question.behaviorObject.rightIcon === 'calendar') {
                                                if (disableAll || question.disabled || question.behaviorObject.isReadOnly) return;
                                                return setShowCalendar(!showCalendar.trim().length ? question.key : '')
                                            }

                                            if (disableAll || question.disabled || question.behaviorObject.isReadOnly) {
                                                setTimeout(() => {
                                                    searchSerpro(question, values && values[question.key], question.behaviorObject.searchQueryId, questionnaire, setFieldValue, true);
                                                    searchZipCode(values && values[question.key], question.behaviorObject.searchQueryId, setFieldValue, question);
                                                }, 350)
                                            }
                                        }}
                                        format={(value) => {
                                            if (question.idDomainQuestion !== 44) return;
                                            return value?.map(v => v.dsAnswerOption)?.join(', ') || ''
                                        }}
                                        component={fieldComponent}
                                        options={getOptions(question, idProduct, idDomainStatusFilter, permissions)}
                                        value={values && values[question.key]}
                                        validation={true} // Adiciona validation como true por padrão
                                        onChange={(value) => {
                                            if (question.disabled || question.behaviorObject.isReadOnly || (question.behaviorObject.rightIcon === 'calendar' && value)) return;

                                            setFieldValue && setFieldValue(question.key, value);
                                            let questionnaireUpdated = questionnaire;

                                            if (!question.behaviorObject.searchQueryId || (question.behaviorObject.searchQueryId === 'fitGetSerproCpnj' && value?.length <= 11) || value === '') {
                                                const idAnswerOption = isObject(value) && value.idAnswerOption ? value.idAnswerOption : undefined;
                                                const answer = idAnswerOption ?
                                                    (value.resultValue != null ? value.resultValue : value.dsAnswerOption) :
                                                    isObject(value) ?
                                                        JSON.stringify(value) :
                                                        value;

                                                questionnaireUpdated = questionnaire.map(v => v.key === question.key ?
                                                    ({
                                                        ...v, idAnswerOption,
                                                        answer: answer === '' ? v.answerJson = '' : answer,
                                                        answerJson: idAnswerOption ? undefined : v.answerJson
                                                    }) : v)

                                                setQuestionnaire(questionnaireUpdated);
                                            }
                                            onQuestionChange && onQuestionChange(question, value, setFieldValue, questionnaireUpdated)
                                        }}
                                        searchRequest={searchRequest}
                                        debounceSearchRequest={debounceSearchRequest}
                                        searchRequestDebounceMS={searchRequestDebounceMS}
                                        question={question}
                                        canGenerate={question.behaviorObject.canGenerate || canGenerate}
                                        onSearchSelect={(selectedValue) => {
                                            if (selectedValue) {
                                                const questionnaireUpdated = questionnaire.map(v => v.key === question.key ? ({
                                                    ...v,
                                                    answerJson: JSON.stringify({ value: selectedValue.value, id: selectedValue.id }),
                                                    answer: JSON.stringify({ value: selectedValue.value, id: selectedValue.id })
                                                }) : v)

                                                setQuestionnaire(questionnaireUpdated);
                                                onQuestionChange && onQuestionChange(question, selectedValue, setFieldValue, questionnaireUpdated)
                                            }
                                        }}
                                        extraExclamationWarning={question.behaviorObject.extraExclamationWarning}
                                    /> : <></>
                                }

                                {showCalendar && showCalendar === question.key ?
                                    <CalendarContainer isFlex={question.behaviorObject.displayFlex}>
                                        <DayPicker
                                            mode="single"
                                            fromYear={1900}
                                            toYear={2100}
                                            captionLayout="dropdown-buttons"
                                            style
                                            locale={ptBR}
                                            firstDayOfWeek={0}
                                            disabled={[{
                                                before: getDisableDays(question.behaviorObject?.fieldMinValue) || new Date(),
                                            }, {
                                                after: getDisableDays(question.behaviorObject?.fieldMaxValue),
                                            }]}
                                            fixedWeeks
                                            onDayClick={(date, { disabled }) => {
                                                if (disabled) return;
                                                let formattedDate = "";
                                                let selectedDate = "";
                                                let momentDate = moment(new Date(date));
                                                if (momentDate.isValid()) {
                                                    formattedDate = momentDate.format(question.behaviorObject.fieldDateFormat || 'MM/DD/YYYY');
                                                    selectedDate = momentDate.format("YYYY-MM-DD");
                                                }

                                                setFieldValue && setFieldValue(question.key, formattedDate);
                                                let questionnaireUpdated = questionnaire.map((v) => v.key === question.key ? { ...v, answer: selectedDate } : v);
                                                setQuestionnaire(questionnaireUpdated);
                                                setShowCalendar("");

                                                //optimization
                                                onQuestionChange && onQuestionChange(question, selectedDate, setFieldValue, questionnaireUpdated)
                                            }}
                                        ></DayPicker>
                                    </CalendarContainer>
                                    : <></>
                                }

                                {/* if question is type switch (yes or no) */}
                                {question.behaviorObject.componentId === 'Switch' ?
                                    <>
                                        {!question?.behaviorObject?.hideDescription && (
                                            <Label
                                                width={question.behaviorObject.width || 35}
                                                isRequired={question.behaviorObject.isRequired}
                                                inline={true}
                                                hideLabelAsterisk={!question.behaviorObject.isRequired}
                                                color={errors && errors[question.key] ? Colors.DANGER : false}
                                                error={errors && errors[question.key]}
                                            >
                                                {`${question.dsQuestion}\n`}
                                            </Label>
                                        )}
                                        <BorderSwitch error={errors && errors[question.key]} verticalAlign={verticalAlign || question.behaviorObject.verticalAlign}>
                                            <Switch
                                                disabled={disableAll || question.disabled}
                                                height={27}
                                                width={53}
                                                checked={values && values[question.key] && (values[question.key] === 'YES' || values[question.key].dsAnswerOption === 'YES' || values[question.key] === 'Yes' || values[question.key].dsAnswerOption === 'Yes' || values[question.key] == 'SIM' || values[question.key] == 'Sim' | values[question.key].dsAnswerOption === 'SIM' || values[question.key].dsAnswerOption === 'Sim')}
                                                onChange={(value) => {
                                                    setFieldError && (setFieldError(question.key, ""))

                                                    const answerOption = value
                                                        ? question.answerOptions.find(v => v.dsAnswerOption.toUpperCase() === "YES" || v.dsAnswerOption.toUpperCase() == "SIM")
                                                        : question.answerOptions.find(v => v.dsAnswerOption.toUpperCase() === "NO" || v.dsAnswerOption.toUpperCase() == "NÃO");

                                                    if (notChangeQuestions?.length && notChangeQuestions.includes(question.idQuestion)) {
                                                        onQuestionChange && onQuestionChange(question, answerOption, setFieldValue, questionnaire)
                                                    } else {
                                                        const questionnaireUpdated = questionnaire.map(v => v.key === question.key
                                                            ? ({
                                                                ...v,
                                                                answer: answerOption.dsAnswerOption,
                                                                idAnswerOption: answerOption.idAnswerOption,
                                                                answerJson: undefined
                                                            })
                                                            : v
                                                        )
                                                        setQuestionnaire(questionnaireUpdated);
                                                        setFieldValue && setFieldValue(question.key, answerOption.dsAnswerOption);
                                                        onQuestionChange && onQuestionChange(question, answerOption, setFieldValue, questionnaireUpdated)
                                                    }
                                                }}
                                                name={question.key}
                                                handleDiameter={20}
                                                checkedIcon={false}
                                                uncheckedIcon={false}
                                                offColor={Colors.WHITE}
                                                onColor={Colors.GRAY[6] || Colors.GREEN}
                                                offHandleColor={errors && errors[question.key] ? Colors.DANGER : Colors.GRAY[6]}
                                                onHandleColor={Colors.WHITE}
                                            />
                                        </BorderSwitch>
                                    </> : <></>}

                                {!disableAll && handleActionButtons(question)}
                            </FieldWrapper>
                            {(question.idDomainQuestion === 270 || question.idDomainQuestion === 271) &&
                                <DragZoneUpload multiple={!singleUpload}
                                    options={getOptions(question, idProduct, idDomainStatusFilter)}
                                    childrenOptions={question.childrenQuestions ? getOptions(question.childrenQuestions[0].idQuestion, idProduct, idDomainStatusFilter) : null}
                                    disabled={disableAll || question.disabled || question.behaviorObject.isReadOnly}
                                    documentTypeRequired={true}
                                    format={question.behaviorObject?.acceptedFileFormat}
                                    documentType={values.documentType}
                                    isDraft={true}
                                    periodicityOptions={periodicityOptions}
                                    periodicityText={periodicityText}
                                    onSuccess={(uploadedFiles) => {
                                        if (!question.answer) question.answer = [];
                                        const questionnaireUpdated = questionnaire.map(v => v.key === question.key
                                            ? ({
                                                ...v,
                                                answer: singleUpload ? uploadedFiles : [...question.answer, ...uploadedFiles],
                                                answerJson: singleUpload ? uploadedFiles : [...question.answer, ...uploadedFiles]
                                            })
                                            : v
                                        )
                                        setQuestionnaire(questionnaireUpdated);
                                        setFieldValue && setFieldValue(question.key, singleUpload ? uploadedFiles : [...question.answer, ...uploadedFiles])
                                        onQuestionChange && onQuestionChange(question, uploadedFiles, setFieldValue, questionnaireUpdated)
                                        onFileUploadSuccess && onFileUploadSuccess(question, uploadedFiles, setFieldValue, questionnaireUpdated)
                                    }}
                                    question={question}
                                    updateIsLoadingStatus={updateIsLoadingStatus}
                                />
                            }

                            {isModalVisible && (
                                <ModalConfirmation
                                    show={isModalVisible}
                                    onConfirm={confirmDelete}
                                    onCancel={confirmCancel}
                                    title="Confirmação de exclusão"
                                    text="Você tem certeza que deseja deletar este anexo?"
                                    textButtonCancel="Não"
                                    textButtonConfirm="Sim"
                                />
                            )}

                            {(question.idDomainQuestion === 270 || question.idDomainQuestion === 271) ? <FieldWrapper
                                mobileWidth={100}
                                tabletWidth={100}
                                desktopWidth={100}
                            >
                                <TagsList
                                    disabled={disableAll || question.disabled || question.behaviorObject.isReadOnly}
                                    tags={question.answer || []}
                                    customColor={customTagListBg}
                                    removeTag={async (currentAttachment) => {
                                        const isConfirmed = await handleDelete();
                                        if (isConfirmed) {
                                            const questionnaireUpdated = questionnaire.map(v => v.key === question.key
                                                ? ({
                                                    ...v,
                                                    answer: question.answer.map(attachment => question.answer.indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true }) : attachment),
                                                    answerJson: question.answer.map(attachment => question.answer.indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true }) : attachment),
                                                })
                                                : v
                                            )
                                            setQuestionnaire(questionnaireUpdated);
                                            setFieldValue && setFieldValue(question.key, question.answer.map(attachment => question.answer.indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true }) : attachment))
                                            onQuestionChange && onQuestionChange(question, currentAttachment, setFieldValue, questionnaireUpdated)
                                            onFileRemoveSuccess && onFileRemoveSuccess({
                                              ...question,
                                              answer: question.answer.map(attachment => question.answer .indexOf(attachment) === currentAttachment ? ({ ...attachment, deleteAttachment: true}) : attachment)
                                            }, currentAttachment, setFieldValue, questionnaireUpdated)
                                        }
                                    }}
                                />
                            </FieldWrapper> : <></>}

                            {question.behaviorObject?.bottomSeparatorLine && <BottomSeparatorLine />}
                            {question?.behaviorObject?.lineBreak && <div style={{ width: "100%" }} />}
                        </React.Fragment>
                    )
                })}
            {(!disableAll) && extraButtons && extraButtons()}
        </Container>
    );
}
